import React from 'react';
import { Field } from 'formik';
import { Row, Col, FormGroup, Input, Label, FormFeedback, Button } from 'reactstrap';
import * as dataSeed from '../shared/DataSeed';
import { AlamatDomisili } from './AlamatDomisili';
import { AlamatNPWP } from './AlamatNPWP';

var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1;
var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd
}
if (mm < 10) {
    mm = '0' + mm
}
today = yyyy + '-' + mm + '-' + dd;

export const Page1PersonalData = ({ errors, touched, values, state, props, onValueChange, setFieldValue, handleChange, handleBlur, onPhotoNPWPClick, imageChange, toggleModalKodeArea }) => (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Data Pribadi</legend>
            <div ref={el => { this.el = el; }} />
            <Row>
                <Col md="12">
                    <FormGroup>
                        <Label>Alamat Sesuai KTP<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="Address1" bsSize="sm" invalid={errors.Address1 && touched.Address1} maxLength={100} />
                        {errors.Address1 && touched.Address1 ? (
                            <FormFeedback>{errors.Address1}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col xs="6">
                    <FormGroup>
                        <Label>RT<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="RT" type="tel" bsSize="sm" maxLength="3" invalid={errors.RT && touched.RT} />
                        {errors.RT && touched.RT ? (
                            <FormFeedback>{errors.RT}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col xs="6">
                    <FormGroup>
                        <Label>RW<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="RW" type="tel" bsSize="sm" maxLength="3" invalid={errors.RW && touched.RW} />
                        {errors.RW && touched.RW ? (
                            <FormFeedback>{errors.RW}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
            <Row>

                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Provinsi<span className="text-danger">*</span> </Label>
                        <Field component="select" name="ProvinceId"
                            className={errors.ProvinceId && touched.ProvinceId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.provinces.map((province, i) =>
                                <option key={i} value={province.Id}>{province.Name}</option>
                            )}
                        </Field>
                        {errors.ProvinceId && touched.ProvinceId ? (
                            <FormFeedback>{errors.ProvinceId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Kota<span className="text-danger">*</span></Label>
                        <Field component="select" name="CityId"
                            className={errors.CityId && touched.CityId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.cities ? props.cities.map((city, i) =>
                                <option key={i} value={city.Id}>{city.Name}</option>
                            ) : null}
                        </Field>
                        {errors.CityId && touched.CityId ? (
                            <FormFeedback>{errors.CityId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>


                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Kecamatan<span className="text-danger">*</span></Label>
                        <Field component="select" name="SubDistrict"
                            className={errors.SubDistrict && touched.SubDistrict ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.districts ? props.districts.map((item, i) =>
                                <option key={i} value={item.Name}>{item.Name}</option>
                            ) : null}
                        </Field>
                        {errors.SubDistrict && touched.SubDistrict ? (
                            <FormFeedback>{errors.SubDistrict}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Kelurahan<span className="text-danger">*</span></Label>
                        <Field component="select" name="Village"
                            className={errors.Village && touched.Village ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            onChange={(e) => onValueChange(e, setFieldValue)}
                        >
                            <option value="">-- Pilih --</option>
                            {props.subDistricts ? props.subDistricts.map((item, i) =>
                                <option key={i} value={item.Name}>{item.Name}</option>
                            ) : null}
                        </Field>
                        {/* <Input tag={Field} name="Village" bsSize="sm" invalid={errors.Village && touched.Village} />*/}
                        {errors.Village && touched.Village ? (
                            <FormFeedback>{errors.Village}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Negara<span className="text-danger">*</span></Label>
                        <Field component="select" name="Country" disabled={true} tag={Field}
                            className={errors.Country && touched.Country ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            <option value="ID">Indonesia</option>
                        </Field>
                        {errors.Country && touched.Country ? (
                            <FormFeedback>{errors.Country}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Kode Pos<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="tel" maxLength="5" name="PostalCode" bsSize="sm" readOnly
                            invalid={errors.PostalCode && touched.PostalCode}
                        />
                        {errors.PostalCode && touched.PostalCode ? (
                            <FormFeedback>{errors.PostalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>

            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label>Pendidikan Terakhir<span className="text-danger">*</span></Label>
                        <Field className={errors.EducationId && touched.EducationId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            component="select" name="EducationId">
                            <option value="">-- Pilih --</option>
                            {dataSeed.educations.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.EducationId && touched.EducationId ? (
                            <FormFeedback>{errors.EducationId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Agama<span className="text-danger">*</span></Label>
                        <Field className={errors.Religion && touched.Religion ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            component="select" name="Religion"
                            validate={errors.Religion && touched.Religion}>
                            <option value="">-- Pilih --</option>
                            {dataSeed.religions.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.Religion && touched.Religion ? (
                            <FormFeedback>{errors.Religion}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Nama Ibu Kandung<span className="text-danger">*</span></Label>
                        <Input tag={Field}
                            invalid={errors.MothersMaidenName && touched.MothersMaidenName}
                            name="MothersMaidenName" bsSize="sm"></Input>

                        {errors.MothersMaidenName && touched.MothersMaidenName ? (
                            <FormFeedback>{errors.MothersMaidenName}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Status Pernikahan <span className="text-danger">*</span></Label>
                        <Field component="select" name="MaritalStatusId" id="MaritalStatus"
                            className={errors.MaritalStatusId && touched.MaritalStatusId ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.maritalStatuses.map((data, index) =>
                                <option value={data.id} key={index}>{data.name}</option>
                            )}
                        </Field>
                        {errors.MaritalStatusId && touched.MaritalStatusId ? (
                            <FormFeedback>{errors.MaritalStatusId}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>

                {(values.MaritalStatusId == 2) ?
                    <Col md="4">
                        <FormGroup>
                            <Label>Nama Pasangan</Label>
                            <Input tag={Field} name="SpouseName" bsSize="sm"
                                className={errors.SpouseName && touched.SpouseName ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'} />
                            {errors.SpouseName && touched.SpouseName ? (
                                <FormFeedback>{errors.SpouseName}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>

            <Row>

                <Col md="4">
                    <FormGroup>
                        <Label>NPWP<span className="text-danger">*</span></Label>
                        <Field component="select" name="NPWP"
                            onChange={(e) => onValueChange(e, setFieldValue)}
                            className={errors.NPWP && touched.NPWP ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                        >
                            <option value="">-- Pilih --</option>
                            {dataSeed.nPWPs.map((NPWP, index) =>
                                <option value={NPWP.id} key={index}>{NPWP.name}</option>
                            )}
                        </Field>
                        {errors.NPWP && touched.NPWP ? (
                            <FormFeedback>{errors.NPWP}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                {/*{(values.NPWP == '2') || (values.NPWP == '3') ?*/}
                {(values.NPWP == "123456") ?
               
                    <React.Fragment>
                        <Col md="6" xs="6">
                            <FormGroup>
                                <Label>Foto NPWP
                                    {(values.NPWP == "2") || (values.NPWP == "3") ?
                                        <span className="text-danger">*</span> : null}
                                </Label>
                                <Input type="file" accept="image/*" id="PhotoNPWP" name="PhotoNPWP"
                                    onClick={() => onPhotoNPWPClick()}
                                    onChange={(e) => imageChange(e, setFieldValue)} capture="camera"
                                />
                                {errors.PhotoNPWP && touched.PhotoNPWP ? (
                                    <FormFeedback>{errors.PhotoNPWP}</FormFeedback>
                                ) : null}
                                <img className="img-fluid" src={values.PhotoNPWP} alt="" />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Nomor NPWP<span className="text-danger">*</span></Label>
                                <Input tag={Field} name="NPWPNumber" bsSize="sm" type="text" disabled={(values.NPWP !== "2") && (values.NPWP !== "3")}
                                    className={errors.NPWPNumber && touched.NPWPNumber ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                                    min="1" />
                                {errors.NPWPNumber && touched.NPWPNumber ? (
                                    <FormFeedback>{errors.NPWPNumber}</FormFeedback>
                                ) : null}
                            </FormGroup>
                        </Col>
                    </React.Fragment>
                    : null
                }
                {/*{(values.NPWP == "1") ?*/}
                {(values.NPWP == "123456") ?
                    <Col md="6">
                        <FormGroup>
                            <Label>Alasan Tidak Memiliki NPWP<span className="text-danger">*</span></Label>
                            <Field component="select" name="NotHavingNPWPReason"
                                className={errors.NotHavingNPWPReason && touched.NotHavingNPWPReason ? 'is-invalid form-control form-control-sm' : 'form-control form-control-sm'}
                            >
                                <option value="">-- Pilih --</option>
                                <option value="1">Belum Membuat NPWP</option>
                                <option value="2">Tidak Memenuhi Syarat Sebagai Pemegang NPWP</option>

                            </Field>
                            {errors.NotHavingNPWPReason && touched.NotHavingNPWPReason ? (
                                <FormFeedback>{errors.NotHavingNPWPReason}</FormFeedback>
                            ) : null}
                        </FormGroup>
                    </Col>
                    : null}
            </Row>
             {/*{(values.NPWP == "2") || (values.NPWP == "3") ?*/}
            {(values.NPWP == "123456") ?
                <Row>
                    <Col md="4" >
                        <FormGroup>
                            <Label>Alamat NPWP Sesuai Dengan KTP</Label>
                            <Row>
                                <Col xs="6">
                                    <div className="custom-control custom-radio">
                                        <Input type="radio" className="custom-control-input" id="customRadio1"
                                            onChange={handleChange} onBlur={handleBlur}
                                            checked={values.NPWPAddressIdemWithKTP == 'true'}
                                            name="NPWPAddressIdemWithKTP" value="true" />
                                        <label className="custom-control-label" htmlFor="customRadio1">Ya</label>
                                    </div>
                                </Col>
                                <Col xs="6">
                                    <div className="custom-control custom-radio">
                                        <Input type="radio" className="custom-control-input" checked={values.NPWPAddressIdemWithKTP == 'false'}
                                            onChange={handleChange} onBlur={handleBlur}
                                            id="customRadio2" name="NPWPAddressIdemWithKTP" value="false" />
                                        <label className="custom-control-label" htmlFor="customRadio2">Tidak</label>
                                    </div>
                                </Col>
                            </Row>
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        {(values.NPWPAddressIdemWithKTP == "false") ?
                            <AlamatNPWP errors={errors} props={props} touched={touched} setFieldValue={setFieldValue} onValueChange={onValueChange} />
                            : null}
                    </Col>
                </Row>
                : null
            }


            <Row>
                <Col md="4" >
                    <FormGroup>
                        <Label>Alamat Domisili Sesuai Dengan KTP</Label>
                        <Row>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" id="ResidentialAddressIdem1"
                                        onChange={handleChange} onBlur={handleBlur}
                                        checked={values.ResidentialAddressIdem == "true"}
                                        name="ResidentialAddressIdem" value="true" />
                                    <label className="custom-control-label" htmlFor="ResidentialAddressIdem1">Ya</label>
                                </div>
                            </Col>
                            <Col xs="6">
                                <div className="custom-control custom-radio">
                                    <Input type="radio" className="custom-control-input" checked={values.ResidentialAddressIdem == "false"}
                                        onChange={handleChange} onBlur={handleBlur}
                                        id="ResidentialAddressIdem2" name="ResidentialAddressIdem" value="false" />
                                    <label className="custom-control-label" htmlFor="ResidentialAddressIdem2">Tidak</label>
                                </div>
                            </Col>
                        </Row>
                    </FormGroup>
                </Col>
            </Row>

            {(values.ResidentialAddressIdem == "false") ?
                <AlamatDomisili errors={errors} props={props} touched={touched} setFieldValue={setFieldValue} onValueChange={onValueChange} />
                : null}

            <Row>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Kode Area<span className="text-danger">*</span></Label>

                        <div class="input-group">
                            <Input tag={Field} placeholder="(cth. 021xx)" type="tel" maxLength="4" name="HomePhoneAreaCode" bsSize="sm"
                                invalid={errors.HomePhoneAreaCode && touched.HomePhoneAreaCode} />
                            <Button className='btn btn-sm input-group-append' type="button" onClick={() => toggleModalKodeArea('HomePhoneAreaCode')} ><i class="bi bi-search"></i></Button>
                            {errors.HomePhoneAreaCode && touched.HomePhoneAreaCode ? (
                                <FormFeedback>{errors.HomePhoneAreaCode}</FormFeedback>
                            ) : null}
                        </div>
                        
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>No Telp Rumah<span className="text-danger">*</span></Label>
                        <Input tag={Field} name="HomePhone" bsSize="sm" type="string" invalid={errors.HomePhone && touched.HomePhone} />
                        {errors.HomePhone && touched.HomePhone ? (
                            <FormFeedback>{errors.HomePhone}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>No Handphone<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 081xx)" name="MobilePhone" bsSize="sm" type="tel" 
                            invalid={errors.MobilePhone && touched.MobilePhone} />
                        {errors.MobilePhone && touched.MobilePhone ? (
                            <FormFeedback>{errors.MobilePhone}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4" xs="6">
                    <FormGroup>
                        <Label>Konfirmasi No Handphone<span className="text-danger">*</span></Label>
                        <Input tag={Field} placeholder="(cth. 081xx)" name="MobilePhoneConfirmation" bsSize="sm" type="tel" 
                            invalid={errors.MobilePhoneConfirmation && touched.MobilePhoneConfirmation} />
                        {errors.MobilePhoneConfirmation && touched.MobilePhoneConfirmation ? (
                            <FormFeedback>{errors.MobilePhoneConfirmation}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Kode AO<span className="text-danger">*</span></Label>
                        <Input tag={Field} type="number"
                            invalid={errors.AccountOfficerCode && touched.AccountOfficerCode}
                            name="AccountOfficerCode" bsSize="sm" min="1"></Input>
                        {errors.AccountOfficerCode && touched.AccountOfficerCode ? (
                            <FormFeedback>{errors.AccountOfficerCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label>Kode Referal (Opsional)</Label>
                        <Input tag={Field} type="text"
                            invalid={errors.RefferalCode && touched.RefferalCode}
                            name="RefferalCode" bsSize="sm" ></Input>
                        {errors.RefferalCode && touched.RefferalCode ? (
                            <FormFeedback>{errors.RefferalCode}</FormFeedback>
                        ) : null}
                    </FormGroup>
                </Col>
            </Row>
        </FormGroup>
        {/* END: Data Diri */}
    </React.Fragment>
);



// WEBPACK FOOTER //
// ./src/components/Page1PersonalData.js